import './UserPage.css'

const UserPage = () => {
    return (
        <div className={"UserPage"}>
            User Page
        </div>
    );
};

export {UserPage};